export default "__VITE_ASSET__D62t4EqB__"